import React from "react";
import KnowledgeSource from "./KnowledgeSource";
import { activeFilterPageInfo } from "../../../../../../services/FilteringUtils";
import KnowledgeSourceService from "../../../../../../services/KnowledgeSourceService";
import KnowledgeSourceClassificationService from "../../../../../../services/KnowledgeSourceClassificationService";
import TableComponentWithDialog from "../../../../page/TableComponentWithDialog";
import { labels } from "../../../../../../localization/labels";
import {
  knowledgeValidationRules as validationRules,
  validateEntity
} from "../../../../../../validators/validationRules";
import TableUtils from "../../../../../core/Table/TableUtils";
import { withRouter } from "react-router-dom";
import CommonUtil from "../../../../../../utils/CommonUtil";
import { withKeycloak } from "@react-keycloak/web";

class KnowledgeSourceContainer extends TableComponentWithDialog {
  constructor(props) {
    super(props);

    this.props = props;
    this.knowledgeSourceService = new KnowledgeSourceService(this.keycloak);
    this.knowledgeSourceClassificationService = new KnowledgeSourceClassificationService(
      this.keycloak
    );

    this.state = {
      ...this.state,
      knowledgeSourceClassifications: undefined
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  getComponentTitle = () => {
    return undefined;
  };

  loadKnowledgeSourceClassifications = () => {
    this.prepareCall(
      this.knowledgeSourceClassificationService.getEntities(
        activeFilterPageInfo,
        this.sortInfo,
        this.onKnowledgeSourceClassificationsLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onKnowledgeSourceClassificationsLoad = data => {
    this.setState({
      knowledgeSourceClassifications: CommonUtil.getDataContent(data) || []
    });
  };

  loadData = pageInfo => {
    this.prepareCall(
      this.knowledgeSourceService.getEntities(
        pageInfo,
        this.sortInfo,
        this.onDataLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onCreateData = source => {
    this.prepareCall(
      this.knowledgeSourceService.postEntity(
        source,
        this.onDataSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  updateData = source => {
    this.prepareCall(
      this.knowledgeSourceService.putEntity(
        source,
        this.onDataSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDeleteData = source => {
    this.prepareCall(
      this.knowledgeSourceService.deleteEntity(
        source,
        this.onDataDeleteResponse,
        this.onDeleteSuccessMessage,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id"
    },
    {
      dataField: "name",
      text: labels.name,
      sort: true,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "description",
      text: labels.description,
      sort: true,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "uri",
      text: labels.uri,
      sort: true,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "institution",
      text: labels.institution,
      sort: true,
      headerClasses: "column-header",
      formatter: TableUtils.textFormatter
    }
  ]);

  resetEntity = () => {
    return {
      name: null,
      description: null
    };
  };

  validator = entity => {
    return validateEntity(entity, validationRules.generalData);
  };

  loadSelectedData = url => {
    this.prepareCall(
      this.knowledgeSourceService.getEntitiesByUrl(
        url,
        this.onSelectedEntityLoad,
        this.messageHandler.handleError
      )
    );
  };

  additionalDataLoad(data) {
    this.prepareCall(
      this.knowledgeSourceClassificationService.getEntitiesByUrl(
        data._links.knowledgeSourceClassification.href,
        this.onKnowledgeSourceClassificationLoad,
        this.messageHandler.handleError
      )
    );

    this.performCalls();
  }

  onKnowledgeSourceClassificationLoad = data => {
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      const knowledgeSourceClassification = dataContent[0];
      const { newEntity, oldEntity } = this.state;

      newEntity.knowledgeSourceClassification = {
        ...knowledgeSourceClassification
      };
      oldEntity.knowledgeSourceClassification = {
        ...knowledgeSourceClassification
      };

      this.setState({ newEntity: newEntity, oldEntity: oldEntity });
    }
  };

  handleEntered() {
    super.handleEntered();
    if (!this.state.knowledgeSourceClassifications) {
      this.loadKnowledgeSourceClassifications();
    }
  }

  render() {
    const maxLength = {
      name: 1024,
      uri: 2000,
      institution: 1024,
      description: 2000
    };
    return (
      <KnowledgeSource
        {...this.renderProps()}
        maxLength={maxLength}
        disabled={this.state.disabled}
        validationRules={validationRules.generalData}
        knowledgeSourceClassifications={
          this.state.knowledgeSourceClassifications
        }
      />
    );
  }
}

export default withKeycloak(withRouter(KnowledgeSourceContainer));
